import { Component, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SubSink } from 'subsink';

import {
  MarketingDataViewModel,
  MerchantSiteViewModel,
} from '@app/api/marketplace/models';

import { MerchantActions, MerchantSelectors } from '../../store/merchant.slice';

@Component({
  selector: 'app-merchant-marketing-data-list',
  templateUrl: './merchant-marketing-data-list.component.html',
  styleUrls: ['./merchant-marketing-data-list.component.scss'],
})
export class MerchantMarketingDataListComponent implements OnInit, OnDestroy {
  isLoading$: Observable<boolean> = this.store.select(
    MerchantSelectors.selectMarketingDataLoading
  );
  isLoaded$: Observable<boolean> = this.store.select(
    MerchantSelectors.selectMarketingDataLoaded
  );
  hasError$: Observable<boolean> = this.store.select(
    MerchantSelectors.selectMarketingDataLoadError
  );
  data$: Observable<MarketingDataViewModel[]> = this.store.select(
    MerchantSelectors.selectMarketingDataList
  );
  areSitesLoaded$: Observable<boolean> = this.store.select(
    MerchantSelectors.selectSitesLoaded
  );
  sites$: Observable<MerchantSiteViewModel[]> = this.store.select(
    MerchantSelectors.selectSiteList
  );

  private subs = new SubSink();

  constructor(private readonly store: Store) {}

  ngOnInit(): void {
    this.subs.sink = this.store
      .select(MerchantSelectors.isBasicDataLoaded)
      .subscribe((res) => {
        if (res) {
          this.subs.sink = this.areSitesLoaded$.subscribe((loaded) => {
            if (!loaded) {
              this.store.dispatch(MerchantActions.loadSites.trigger());
            }
          });
          this.subs.sink = this.isLoaded$.subscribe((loaded) => {
            if (!loaded) {
              this.store.dispatch(MerchantActions.loadMarketingData.trigger());
            }
          });
        }
      });
  }

  getSiteNamesByIds(
    sites: MerchantSiteViewModel[] | null,
    siteIds: string[]
  ): string[] {
    return (
      sites?.filter((s) => siteIds.includes(s.id)).map((s) => s.name) ?? []
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
